import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  title: {
    id: 'product_jp_paypay_modal_title',
    defaultMessage: 'How to get PayPay points',
  },
  subtitle: {
    id: 'product_jp_paypay_modal_subtitle',
    defaultMessage: 'Get up to {points}',
  },
  formattedPoints: {
    id: 'product_jp_paypay_modal_formatted_points',
    defaultMessage: '{points}pt',
  },
  description: {
    id: 'product_jp_paypay_modal_description',
    defaultMessage:
      'Pay with PayPay QR and earn points based on your purchase amount',
  },
  list: {
    id: 'product_jp_paypay_modal_list',
    defaultMessage: 'How to earn points :',
  },
  item1: {
    id: 'product_jp_paypay_modal_item1',
    defaultMessage: 'Add an item(s) to cart',
  },
  item2: {
    id: 'product_jp_paypay_modal_item2',
    defaultMessage: 'Select PayPay at payment page',
  },
  item3: {
    id: 'product_jp_paypay_modal_item3',
    defaultMessage:
      'After payment, you’ll get points based on your purchase amount',
  },
} as Record<string, I18nDefinition>
